import { genericGet } from "../../services/api.service";
import { EntityConfig } from "../..";
import { EncomendasTableConfigs } from "./Encomendas.config";
import { useFormType } from "../../form/hooks/useForm";

export const NotasEncomendaTableConfigs : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
    },
    {
      id: 'code',
      label: 'Código',
      type: 'text',
      filterable: true,
      nonEditable: true
    },
    {
      id: 'referenciaOrcamento',
      label: 'V/Ref',
      type: 'text',
      filterable: true
    },
    {
        id: 'fornecedor',
        label: 'Fornecedor',
        type: 'select',
        filterable: true,
        routable: true,
        options: {
          name: 'Fornecedor',
          route: 'fornecedores',
          value: 'id',
          label: 'name',
          getter: () => genericGet('/findByFilter/fornecedores'),
          searcheable: true
        }
      },
      {
        id: 'obra',
        label: 'Obra',
        type: 'select',
        filterable: true,
        routable: true,
        options: {
          name: 'Obra',
          route: 'obras',
          value: 'id',
          label: 'number',
          getter: ()=>genericGet('/findByFilter/obras'),
          searcheable: true
        }
      },
      {
        id: 'observacoes',
        label: 'Observações',
        type: 'text'
      },
      {
        id: 'deliveryDate',
        label: 'Data de entrega',
        type: 'date',
        filterable: true,
        existsOnCopyForm: true
      }, {
        id: 'entradaMaterial',
        label: 'Entrada Material',
        type: 'select',
        nonEditable: true, 
        routable: true,
        options : {
          name: 'Entrada Material',
          route: 'entradas-material',
          value: 'id',
          label: 'id',
          
        }

      },
      {
        id: 'encomendas',
        label: 'Encomendas',
        type: 'multiple-create',
        routable: true,
        options: {
          name: 'Encomendas',
          route: 'encomendas',
          ref: 'encomendas',
          value: 'id',
          label: 'designacao',
          subFormConfig: EncomendasTableConfigs,
          nestPathGetter: (form: useFormType | undefined, i: number) => form?.state['encomendas'][i]
        }
      }
  ];
  